import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import Tooltip from '../ToolTip';

interface NotificationIconProps {
  notifications: number;
  onClick?: () => void;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ notifications, onClick }) => {
  return (
    <Tooltip placement="bottom" bgColor="bg-gray-200" message={'Notifications'}>
      <div className="relative h-7 w-7 rounded-full p-1 flex items-center justify-center bg-white hover:bg-primary-main ease-in-out duration-200" onClick={onClick}>
        <BellIcon className="h-4 w-4" />
        {notifications > 0 && (
          <span className="absolute -top-2 -right-2 flex w-5 h-5 bg-red-500 text-white text-xs font-semibold rounded-full items-center justify-center">
            {notifications}
          </span>
        )}
      </div>
    </Tooltip>
  );
};

export default NotificationIcon;


